import PageHead from "../Head";
import { withGuestSSR } from "@/lib/withGuestSSR";

import Context from "@/context/Context";
import NewPassword from "@/my_components/_NewPassword/NewPassword";

const NewPasswordPage = () => {
  return (
      <Context>
        <PageHead title="Reset Password | SmartTech Academy" />

        <NewPassword />
      </Context>
  );
};

export default NewPasswordPage;

export const getServerSideProps = withGuestSSR();
